import React from "react"
import propTypes from "prop-types"
import { Button } from "reactstrap"

const PresentationItemList = ({ item, canDelete, canEdit, openEditModal, openDeleteModal }) => {
  const renderEditButton = () => {
    if (!canEdit) {
      return null
    }

    return (
      <Button color="primary" className="m-1" onClick={() => openEditModal(item.id)}>
        <i className="fa fa-edit" />
      </Button>
    )
  }

  const renderDeleteButton = () => {
    if (!canDelete) {
      return null
    }

    return (
      <Button color="danger" onClick={() => openDeleteModal(item)}>
        <i className="fa fa-trash" />
      </Button>
    )
  }

  return (
    <tr key={item.id}>
      <td>{item.key}</td>
      <td>{item.description}</td>
      <td>{item.presentation_unit}</td>
      <td className="text-center">
        {renderEditButton()}
        {renderDeleteButton()}
      </td>
    </tr>
  )
}

PresentationItemList.propTypes = {
  item: propTypes.object,
  canDelete: propTypes.bool,
  canEdit: propTypes.bool,
  openEditModal: propTypes.func,
  openDeleteModal: propTypes.func,
}

export default PresentationItemList
